// eslint-disable-next-line import/no-anonymous-default-export
export default function (fields, index) {
  const { tilesData, rects } = fields;

  return { ...tilesData[index], selectedRect: rects[index] };
}
